/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["table[_ngcontent-%COMP%]{width:100%;border-width:0;font-size:14px;border-spacing:0}thead[_ngcontent-%COMP%]{background-color:#3f51b5;color:#fff}a[_ngcontent-%COMP%]{text-decoration:none;color:rgba(0,0,0,.87)}a[_ngcontent-%COMP%]:hover{text-decoration:underline;color:#3f51b5}a[_ngcontent-%COMP%]:focus{outline:0}\n/*# sourceMappingURL=pull-request-builds.component.css.map*/"];
export { styles as styles };
